import { n as kt } from "../chunk-Bpqwac5z.js";
import { t as It } from "../common-Cd7R8f1s.js";
import { n as $ } from "../Logger-CmiOOsKC.js";
import { t as nt } from "../Utility-CviQuQTA.js";
import { t as Me } from "../imageanchor-DusNzbVp.js";
import { n as Bt, r as z } from "../abort-qw0xAdg5.js";
import { n as Jt, t as Ht } from "../zipAnchorConversion-B_49vmUS.js";
import { o as Mt } from "../documentRoot-BRVSd6Oa.js";
import { _ as Gt, b as at, d as zt, f as Wt, g as oo, h as no, m as it, n as Vt, p as ao, t as Kt, v as Xt, x as io, y as uo } from "../ImageMarkerLoader-aTenj78C.js";
import { i as lo, r as ho } from "../localizerTracking-DNXVMp7I.js";
import { a as po, c as mo, i as yo, n as bo, o as Eo, r as go, s as To, t as So } from "../serverTools-CRll2xrE.js";
import { t as Oo } from "../types-DUkCe832.js";
import { Quaternion as ut } from "@babylonjs/core/Maths/math.vector.js";
function ct(e, t) {
  if (t.url) return t.url;
  if (!t.id) throw new Error("[contentDownloadUrl] cannot synthesize URL: content has neither url nor id");
  const r = Qt(t.name) ?? "zip";
  return `${e.replace(/\/$/, "")}/scene-content-files/${t.id}.${r}`;
}
function Qt(e) {
  if (!e) return null;
  const t = e.lastIndexOf(".");
  return t < 0 || t === e.length - 1 ? null : e.slice(t + 1).toLowerCase();
}
function lt(e) {
  return e.name ?? `Content (${e.contentType ?? "unknown"})`;
}
function dt(e, t) {
  return e.replace(/\/$/, "") + "/" + t.replace(/^\//, "");
}
async function Po(e, t, r, s, o = {}) {
  const n = {
    rootLoaded: !1,
    rootMissing: !1,
    anchorShown: !1
  }, a = er(r), u = a ? ct(s, a) : null, c = Zt(t, u), d = ht(u);
  if (a && u) {
    $.log(`[CMS] Opening RootContent: ${lt(a)}`);
    try {
      await e.open({
        src: u,
        onProgress: o.onProgress,
        deferRendering: o.deferRendering
      }), n.rootLoaded = !0;
    } catch (l) {
      if (Bt(l) && !e.traceScene) throw l;
      $.error(`[CMS] Failed to open RootContent: ${String(l)}`), e.clearScene();
    }
  } else a || ($.warn(`[CMS] Scene has no RootContent row (${r.length} content entries total)`), e.clearScene(), n.rootMissing = !0);
  if (t.imageUrl) {
    const l = dt(s, t.imageUrl), y = t.imageWidth ?? o.defaultAnchorWidthMeters ?? 0.2, E = n.rootMissing && t.imageOrientation == null ? It.Vertical : Gt(t.imageOrientation), g = t.imagePitchDegrees ?? 0, S = e.traceScene?.getSessionDocumentRoot() ?? e.traceScene?.getSceneRoot();
    if (S) {
      c && n.rootLoaded && Yt(S);
      const b = t.anchorPlacement;
      if (b) {
        const f = b.rotationSource === "legacy_heuristic", m = {
          t: [...b.t],
          q: f ? zt(S, E, g) : [...b.q]
        }, O = at(m);
        await S.setBehavior(Me, {
          src: l,
          widthMeters: y,
          ...O ?? {}
        }), z(e), o.skipAnchorAlignment || Vt(e, m, y), n.anchorPlacement = {
          placementId: b.id,
          pose: m,
          resolvedFromHeuristic: f
        };
      } else
        await S.setBehavior(Me, {
          src: l,
          widthMeters: y,
          orientation: E,
          pitchDegrees: g
        }), z(e), o.skipAnchorAlignment || Kt(e, y);
      o.skipAnchorAlignment && !d && tr(S), n.anchorShown = !0;
    } else $.warn("[CMS] Cannot attach ImageAnchor — no scene root");
  }
  return n;
}
function Zt(e, t) {
  return !!e.imageUrl && ht(t);
}
function ht(e) {
  return !!e && nt.getFileExtensionFromSrc(e) === "zip";
}
function Yt(e) {
  for (const t of e.getChildren()) {
    const r = t.transform.position, s = Ht([
      r.x,
      r.y,
      r.z
    ]);
    r.set(s[0], s[1], s[2]);
    const o = t.transform.rotationQuaternion;
    if (o) {
      const n = Jt([
        o.x,
        o.y,
        o.z,
        o.w
      ]);
      t.transform.rotationQuaternion = new ut(n[0], n[1], n[2], n[3]);
    }
  }
}
function er(e) {
  return e.find((t) => t.contentType === "RootContent") ?? null;
}
function tr(e) {
  e.transform.position.set(0, 0, 0), e.transform.rotationQuaternion = ut.Identity(), e.transform.scaling.set(1, 1, 1);
}
var rr = ["EditorContent"];
async function Co(e, t, r, s = {}) {
  if (!e.traceScene) throw new Error("attachCmsContent: viewer.traceScene is not initialized");
  const o = s.contentTypes ?? rr, n = t.filter((u) => u.contentType != null && o.includes(u.contentType)), a = [];
  for (const u of n) {
    const c = await or(e, u, r, s.parent);
    z(e), a.push({
      content: u,
      sceneObject: c
    });
  }
  return a;
}
function sr(e, t) {
  const r = nt.getFileExtensionFromSrc(e).toLowerCase();
  return r ? r === "gltf" : (t.name ?? "").toLowerCase().endsWith(".gltf");
}
async function or(e, t, r, s) {
  const o = e.traceScene, n = ct(r, t), a = lt(t), u = o.sceneName;
  try {
    if (sr(n, t)) {
      const c = await o.attachDocumentFromUrl(n, s);
      return c ? (Mt(c, c.getParent()), $.log(`[CMS] Attached editor document "${a}" as "${c.name}"`), c) : (z(e), $.error(`[CMS] Attaching "${a}" produced no content`), null);
    }
    return await nr(e, t, n, a, s);
  } catch (c) {
    return z(e), $.error(`[CMS] Failed to attach "${a}": ${String(c)}`), null;
  } finally {
    o.sceneName = u;
  }
}
async function nr(e, t, r, s, o) {
  const n = e.traceScene;
  let a;
  try {
    const l = await fetch(r);
    if (!l.ok)
      return z(e), $.error(`[CMS] Failed to download content "${s}" (${l.status})`), null;
    a = await l.blob();
  } catch (l) {
    return z(e), $.error(`[CMS] Network error downloading "${s}": ${String(l)}`), null;
  }
  const u = `${t.id ?? "content"}.tracex`, c = (await e.import(a, u, s)).sceneObject, d = [...c.getChildren()];
  if (o) {
    for (const l of d) n.reparentSceneObjectPreservingWorld(l, o);
    return n.deleteSceneObject(c), $.log(`[CMS] Attached legacy bundle "${s}" (${d.length} children)`), d[0] ?? null;
  }
  return $.log(`[CMS] Attached legacy bundle "${s}" at scene root`), c;
}
var ar = "Image";
function Le(e) {
  return e?.find((t) => t.anchorType === "Image") ?? e?.[0];
}
function Ao(e) {
  const t = pt(e);
  return t ? it(t) !== void 0 : ft(e);
}
function ft(e) {
  return Le(e?.sceneAccessors)?.anchorType === ar;
}
function pt(e) {
  const t = Xt(e);
  if (!t) return null;
  const r = t.filter((s) => s.localizer?.kind !== Wt);
  return r.length === 0 && e?.imageUrl && ft(e) ? null : r;
}
function qo(e, t = {}) {
  const r = pt(e);
  if (r) return ir(e, r, t.includeDisabledPrimary);
  const s = Le(e?.sceneAccessors);
  if (s?.anchorType !== "Image") return {
    imageUrl: null,
    imageWidth: null,
    imageOrientation: null,
    imagePitchDegrees: null
  };
  const o = e?.imageWidth, n = typeof o == "number" ? o || null : o && Number(o) || null;
  return {
    imageUrl: e?.imageUrl ?? null,
    imageWidth: n,
    imageOrientation: s.orientation ?? null,
    imagePitchDegrees: s.pitchDegrees ?? null
  };
}
function ir(e, t, r = !1) {
  const s = r ? t.find((a) => a.isPrimary && a.localizer?.kind === "image" && a.localizer.imageUrl) : it(t);
  if (!s?.localizer) return {
    imageUrl: null,
    imageWidth: null,
    imageOrientation: null,
    imagePitchDegrees: null,
    anchorPlacement: null
  };
  let o = null, n = null;
  if (s.rotationSource === "legacy_heuristic") {
    const a = Le(e?.sceneAccessors);
    o = a?.orientation ?? null, n = a?.pitchDegrees ?? null;
  } else {
    const a = at(s);
    o = a?.orientation ?? null, n = a?.pitchDegrees ?? null;
  }
  return {
    imageUrl: s.localizer.imageUrl,
    imageWidth: s.localizer.widthM,
    imageOrientation: o,
    imagePitchDegrees: n,
    anchorPlacement: {
      id: s.id,
      t: [...s.t],
      q: [...s.q],
      rotationSource: s.rotationSource
    }
  };
}
function ur(e) {
  return /^[a-z][a-z0-9+.-]*:/i.test(e);
}
function vo(e, t, r) {
  const s = [];
  for (const o of e ?? []) {
    const n = r?.placementId === o.id ? r.pose : null, a = o.localizer?.imageUrl;
    s.push({
      ...o,
      t: n ? [...n.t] : [...o.t],
      q: n ? [...n.q] : [...o.q],
      rotationSource: n ? "explicit" : o.rotationSource,
      localizer: o.localizer ? {
        ...o.localizer,
        imageUrl: a ? ur(a) ? a : dt(t, a) : null
      } : null
    });
  }
  return s;
}
function mt(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
var { toString: cr } = Object.prototype, { getPrototypeOf: pe } = Object, { iterator: me, toStringTag: yt } = Symbol, ye = /* @__PURE__ */ ((e) => (t) => {
  const r = cr.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), x = (e) => (e = e.toLowerCase(), (t) => ye(t) === e), be = (e) => (t) => typeof t === e, { isArray: Q } = Array, X = be("undefined");
function te(e) {
  return e !== null && !X(e) && e.constructor !== null && !X(e.constructor) && j(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
var bt = x("ArrayBuffer");
function lr(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && bt(e.buffer), t;
}
var dr = be("string"), j = be("function"), Et = be("number"), re = (e) => e !== null && typeof e == "object", hr = (e) => e === !0 || e === !1, le = (e) => {
  if (ye(e) !== "object") return !1;
  const t = pe(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(yt in e) && !(me in e);
}, fr = (e) => {
  if (!re(e) || te(e)) return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, pr = x("Date"), mr = x("File"), yr = (e) => !!(e && typeof e.uri < "u"), br = (e) => e && typeof e.getParts < "u", Er = x("Blob"), gr = x("FileList"), Tr = (e) => re(e) && j(e.pipe);
function Sr() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
var Ge = Sr(), ze = typeof Ge.FormData < "u" ? Ge.FormData : void 0, wr = (e) => {
  if (!e) return !1;
  if (ze && e instanceof ze) return !0;
  const t = pe(e);
  if (!t || t === Object.prototype || !j(e.append)) return !1;
  const r = ye(e);
  return r === "formdata" || r === "object" && j(e.toString) && e.toString() === "[object FormData]";
}, Or = x("URLSearchParams"), [Rr, Pr, Cr, Ar] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(x), qr = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function se(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u") return;
  let s, o;
  if (typeof e != "object" && (e = [e]), Q(e)) for (s = 0, o = e.length; s < o; s++) t.call(null, e[s], s, e);
  else {
    if (te(e)) return;
    const n = r ? Object.getOwnPropertyNames(e) : Object.keys(e), a = n.length;
    let u;
    for (s = 0; s < a; s++)
      u = n[s], t.call(null, e[u], u, e);
  }
}
function gt(e, t) {
  if (te(e)) return null;
  t = t.toLowerCase();
  const r = Object.keys(e);
  let s = r.length, o;
  for (; s-- > 0; )
    if (o = r[s], t === o.toLowerCase()) return o;
  return null;
}
var M = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Tt = (e) => !X(e) && e !== M;
function Ae(...e) {
  const { caseless: t, skipUndefined: r } = Tt(this) && this || {}, s = {}, o = (n, a) => {
    if (a === "__proto__" || a === "constructor" || a === "prototype") return;
    const u = t && gt(s, a) || a, c = qe(s, u) ? s[u] : void 0;
    le(c) && le(n) ? s[u] = Ae(c, n) : le(n) ? s[u] = Ae({}, n) : Q(n) ? s[u] = n.slice() : (!r || !X(n)) && (s[u] = n);
  };
  for (let n = 0, a = e.length; n < a; n++) e[n] && se(e[n], o);
  return s;
}
var vr = (e, t, r, { allOwnKeys: s } = {}) => (se(t, (o, n) => {
  r && j(o) ? Object.defineProperty(e, n, {
    __proto__: null,
    value: mt(o, r),
    writable: !0,
    enumerable: !0,
    configurable: !0
  }) : Object.defineProperty(e, n, {
    __proto__: null,
    value: o,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}, { allOwnKeys: s }), e), jr = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Dr = (e, t, r, s) => {
  e.prototype = Object.create(t.prototype, s), Object.defineProperty(e.prototype, "constructor", {
    __proto__: null,
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    __proto__: null,
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, Lr = (e, t, r, s) => {
  let o, n, a;
  const u = {};
  if (t = t || {}, e == null) return t;
  do {
    for (o = Object.getOwnPropertyNames(e), n = o.length; n-- > 0; )
      a = o[n], (!s || s(a, e, t)) && !u[a] && (t[a] = e[a], u[a] = !0);
    e = r !== !1 && pe(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, _r = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const s = e.indexOf(t, r);
  return s !== -1 && s === r;
}, $r = (e) => {
  if (!e) return null;
  if (Q(e)) return e;
  let t = e.length;
  if (!Et(t)) return null;
  const r = new Array(t);
  for (; t-- > 0; ) r[t] = e[t];
  return r;
}, xr = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && pe(Uint8Array)), Ur = (e, t) => {
  const r = (e && e[me]).call(e);
  let s;
  for (; (s = r.next()) && !s.done; ) {
    const o = s.value;
    t.call(e, o[0], o[1]);
  }
}, Fr = (e, t) => {
  let r;
  const s = [];
  for (; (r = e.exec(t)) !== null; ) s.push(r);
  return s;
}, Nr = x("HTMLFormElement"), kr = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(r, s, o) {
  return s.toUpperCase() + o;
}), qe = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), Ir = x("RegExp"), St = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), s = {};
  se(r, (o, n) => {
    let a;
    (a = t(o, n, e)) !== !1 && (s[n] = a || o);
  }), Object.defineProperties(e, s);
}, Br = (e) => {
  St(e, (t, r) => {
    if (j(e) && [
      "arguments",
      "caller",
      "callee"
    ].includes(r)) return !1;
    const s = e[r];
    if (j(s)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, Jr = (e, t) => {
  const r = {}, s = (o) => {
    o.forEach((n) => {
      r[n] = !0;
    });
  };
  return Q(e) ? s(e) : s(String(e).split(t)), r;
}, Hr = () => {
}, Mr = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function Gr(e) {
  return !!(e && j(e.append) && e[yt] === "FormData" && e[me]);
}
var zr = (e) => {
  const t = new Array(10), r = (s, o) => {
    if (re(s)) {
      if (t.indexOf(s) >= 0) return;
      if (te(s)) return s;
      if (!("toJSON" in s)) {
        t[o] = s;
        const n = Q(s) ? [] : {};
        return se(s, (a, u) => {
          const c = r(a, o + 1);
          !X(c) && (n[u] = c);
        }), t[o] = void 0, n;
      }
    }
    return s;
  };
  return r(e, 0);
}, Wr = x("AsyncFunction"), Vr = (e) => e && (re(e) || j(e)) && j(e.then) && j(e.catch), wt = ((e, t) => e ? setImmediate : t ? ((r, s) => (M.addEventListener("message", ({ source: o, data: n }) => {
  o === M && n === r && s.length && s.shift()();
}, !1), (o) => {
  s.push(o), M.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(typeof setImmediate == "function", j(M.postMessage)), Kr = typeof queueMicrotask < "u" ? queueMicrotask.bind(M) : typeof process < "u" && process.nextTick || wt, Xr = (e) => e != null && j(e[me]), i = {
  isArray: Q,
  isArrayBuffer: bt,
  isBuffer: te,
  isFormData: wr,
  isArrayBufferView: lr,
  isString: dr,
  isNumber: Et,
  isBoolean: hr,
  isObject: re,
  isPlainObject: le,
  isEmptyObject: fr,
  isReadableStream: Rr,
  isRequest: Pr,
  isResponse: Cr,
  isHeaders: Ar,
  isUndefined: X,
  isDate: pr,
  isFile: mr,
  isReactNativeBlob: yr,
  isReactNative: br,
  isBlob: Er,
  isRegExp: Ir,
  isFunction: j,
  isStream: Tr,
  isURLSearchParams: Or,
  isTypedArray: xr,
  isFileList: gr,
  forEach: se,
  merge: Ae,
  extend: vr,
  trim: qr,
  stripBOM: jr,
  inherits: Dr,
  toFlatObject: Lr,
  kindOf: ye,
  kindOfTest: x,
  endsWith: _r,
  toArray: $r,
  forEachEntry: Ur,
  matchAll: Fr,
  isHTMLForm: Nr,
  hasOwnProperty: qe,
  hasOwnProp: qe,
  reduceDescriptors: St,
  freezeMethods: Br,
  toObjectSet: Jr,
  toCamelCase: kr,
  noop: Hr,
  toFiniteNumber: Mr,
  findKey: gt,
  global: M,
  isContextDefined: Tt,
  isSpecCompliantForm: Gr,
  toJSONObject: zr,
  isAsyncFn: Wr,
  isThenable: Vr,
  setImmediate: wt,
  asap: Kr,
  isIterable: Xr
}, Qr = i.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Zr = (e) => {
  const t = {};
  let r, s, o;
  return e && e.split(`
`).forEach(function(a) {
    o = a.indexOf(":"), r = a.substring(0, o).trim().toLowerCase(), s = a.substring(o + 1).trim(), !(!r || t[r] && Qr[r]) && (r === "set-cookie" ? t[r] ? t[r].push(s) : t[r] = [s] : t[r] = t[r] ? t[r] + ", " + s : s);
  }), t;
}, We = /* @__PURE__ */ Symbol("internals"), Yr = /[^\x09\x20-\x7E\x80-\xFF]/g;
function es(e) {
  let t = 0, r = e.length;
  for (; t < r; ) {
    const s = e.charCodeAt(t);
    if (s !== 9 && s !== 32) break;
    t += 1;
  }
  for (; r > t; ) {
    const s = e.charCodeAt(r - 1);
    if (s !== 9 && s !== 32) break;
    r -= 1;
  }
  return t === 0 && r === e.length ? e : e.slice(t, r);
}
function ee(e) {
  return e && String(e).trim().toLowerCase();
}
function ts(e) {
  return es(e.replace(Yr, ""));
}
function de(e) {
  return e === !1 || e == null ? e : i.isArray(e) ? e.map(de) : ts(String(e));
}
function rs(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let s;
  for (; s = r.exec(e); ) t[s[1]] = s[2];
  return t;
}
var ss = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Oe(e, t, r, s, o) {
  if (i.isFunction(s)) return s.call(this, t, r);
  if (o && (t = r), !!i.isString(t)) {
    if (i.isString(s)) return t.indexOf(s) !== -1;
    if (i.isRegExp(s)) return s.test(t);
  }
}
function os(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, s) => r.toUpperCase() + s);
}
function ns(e, t) {
  const r = i.toCamelCase(" " + t);
  [
    "get",
    "set",
    "has"
  ].forEach((s) => {
    Object.defineProperty(e, s + r, {
      __proto__: null,
      value: function(o, n, a) {
        return this[s].call(this, t, o, n, a);
      },
      configurable: !0
    });
  });
}
var q = class {
  constructor(e) {
    e && this.set(e);
  }
  set(e, t, r) {
    const s = this;
    function o(a, u, c) {
      const d = ee(u);
      if (!d) throw new Error("header name must be a non-empty string");
      const l = i.findKey(s, d);
      (!l || s[l] === void 0 || c === !0 || c === void 0 && s[l] !== !1) && (s[l || u] = de(a));
    }
    const n = (a, u) => i.forEach(a, (c, d) => o(c, d, u));
    if (i.isPlainObject(e) || e instanceof this.constructor) n(e, t);
    else if (i.isString(e) && (e = e.trim()) && !ss(e)) n(Zr(e), t);
    else if (i.isObject(e) && i.isIterable(e)) {
      let a = {}, u, c;
      for (const d of e) {
        if (!i.isArray(d)) throw TypeError("Object iterator must return a key-value pair");
        a[c = d[0]] = (u = a[c]) ? i.isArray(u) ? [...u, d[1]] : [u, d[1]] : d[1];
      }
      n(a, t);
    } else e != null && o(t, e, r);
    return this;
  }
  get(e, t) {
    if (e = ee(e), e) {
      const r = i.findKey(this, e);
      if (r) {
        const s = this[r];
        if (!t) return s;
        if (t === !0) return rs(s);
        if (i.isFunction(t)) return t.call(this, s, r);
        if (i.isRegExp(t)) return t.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, t) {
    if (e = ee(e), e) {
      const r = i.findKey(this, e);
      return !!(r && this[r] !== void 0 && (!t || Oe(this, this[r], r, t)));
    }
    return !1;
  }
  delete(e, t) {
    const r = this;
    let s = !1;
    function o(n) {
      if (n = ee(n), n) {
        const a = i.findKey(r, n);
        a && (!t || Oe(r, r[a], a, t)) && (delete r[a], s = !0);
      }
    }
    return i.isArray(e) ? e.forEach(o) : o(e), s;
  }
  clear(e) {
    const t = Object.keys(this);
    let r = t.length, s = !1;
    for (; r--; ) {
      const o = t[r];
      (!e || Oe(this, this[o], o, e, !0)) && (delete this[o], s = !0);
    }
    return s;
  }
  normalize(e) {
    const t = this, r = {};
    return i.forEach(this, (s, o) => {
      const n = i.findKey(r, o);
      if (n) {
        t[n] = de(s), delete t[o];
        return;
      }
      const a = e ? os(o) : String(o).trim();
      a !== o && delete t[o], t[a] = de(s), r[a] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const t = /* @__PURE__ */ Object.create(null);
    return i.forEach(this, (r, s) => {
      r != null && r !== !1 && (t[s] = e && i.isArray(r) ? r.join(", ") : r);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...t) {
    const r = new this(e);
    return t.forEach((s) => r.set(s)), r;
  }
  static accessor(e) {
    const t = (this[We] = this[We] = { accessors: {} }).accessors, r = this.prototype;
    function s(o) {
      const n = ee(o);
      t[n] || (ns(r, o), t[n] = !0);
    }
    return i.isArray(e) ? e.forEach(s) : s(e), this;
  }
};
q.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
i.reduceDescriptors(q.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(s) {
      this[r] = s;
    }
  };
});
i.freezeMethods(q);
var as = "[REDACTED ****]";
function is(e) {
  if (i.hasOwnProp(e, "toJSON")) return !0;
  let t = Object.getPrototypeOf(e);
  for (; t && t !== Object.prototype; ) {
    if (i.hasOwnProp(t, "toJSON")) return !0;
    t = Object.getPrototypeOf(t);
  }
  return !1;
}
function us(e, t) {
  const r = new Set(t.map((n) => String(n).toLowerCase())), s = [], o = (n) => {
    if (n === null || typeof n != "object" || i.isBuffer(n)) return n;
    if (s.indexOf(n) !== -1) return;
    n instanceof q && (n = n.toJSON()), s.push(n);
    let a;
    if (i.isArray(n))
      a = [], n.forEach((u, c) => {
        const d = o(u);
        i.isUndefined(d) || (a[c] = d);
      });
    else {
      if (!i.isPlainObject(n) && is(n))
        return s.pop(), n;
      a = /* @__PURE__ */ Object.create(null);
      for (const [u, c] of Object.entries(n)) {
        const d = r.has(u.toLowerCase()) ? as : o(c);
        i.isUndefined(d) || (a[u] = d);
      }
    }
    return s.pop(), a;
  };
  return o(e);
}
var p = class Ot extends Error {
  static from(t, r, s, o, n, a) {
    const u = new Ot(t.message, r || t.code, s, o, n);
    return u.cause = t, u.name = t.name, t.status != null && u.status == null && (u.status = t.status), a && Object.assign(u, a), u;
  }
  constructor(t, r, s, o, n) {
    super(t), Object.defineProperty(this, "message", {
      __proto__: null,
      value: t,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, r && (this.code = r), s && (this.config = s), o && (this.request = o), n && (this.response = n, this.status = n.status);
  }
  toJSON() {
    const t = this.config, r = t && i.hasOwnProp(t, "redact") ? t.redact : void 0, s = i.isArray(r) && r.length > 0 ? us(t, r) : i.toJSONObject(t);
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: s,
      code: this.code,
      status: this.status
    };
  }
};
p.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
p.ERR_BAD_OPTION = "ERR_BAD_OPTION";
p.ECONNABORTED = "ECONNABORTED";
p.ETIMEDOUT = "ETIMEDOUT";
p.ECONNREFUSED = "ECONNREFUSED";
p.ERR_NETWORK = "ERR_NETWORK";
p.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
p.ERR_DEPRECATED = "ERR_DEPRECATED";
p.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
p.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
p.ERR_CANCELED = "ERR_CANCELED";
p.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
p.ERR_INVALID_URL = "ERR_INVALID_URL";
p.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
function ve(e) {
  return i.isPlainObject(e) || i.isArray(e);
}
function Rt(e) {
  return i.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Re(e, t, r) {
  return e ? e.concat(t).map(function(o, n) {
    return o = Rt(o), !r && n ? "[" + o + "]" : o;
  }).join(r ? "." : "") : t;
}
function cs(e) {
  return i.isArray(e) && !e.some(ve);
}
var ls = i.toFlatObject(i, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Ee(e, t, r) {
  if (!i.isObject(e)) throw new TypeError("target must be an object");
  t = t || new FormData(), r = i.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(f, m) {
    return !i.isUndefined(m[f]);
  });
  const s = r.metaTokens, o = r.visitor || y, n = r.dots, a = r.indexes, u = r.Blob || typeof Blob < "u" && Blob, c = r.maxDepth === void 0 ? 100 : r.maxDepth, d = u && i.isSpecCompliantForm(t);
  if (!i.isFunction(o)) throw new TypeError("visitor must be a function");
  function l(b) {
    if (b === null) return "";
    if (i.isDate(b)) return b.toISOString();
    if (i.isBoolean(b)) return b.toString();
    if (!d && i.isBlob(b)) throw new p("Blob is not supported. Use a Buffer instead.");
    return i.isArrayBuffer(b) || i.isTypedArray(b) ? d && typeof Blob == "function" ? new Blob([b]) : Buffer.from(b) : b;
  }
  function y(b, f, m) {
    let O = b;
    if (i.isReactNative(t) && i.isReactNativeBlob(b))
      return t.append(Re(m, f, n), l(b)), !1;
    if (b && !m && typeof b == "object") {
      if (i.endsWith(f, "{}"))
        f = s ? f : f.slice(0, -2), b = JSON.stringify(b);
      else if (i.isArray(b) && cs(b) || (i.isFileList(b) || i.endsWith(f, "[]")) && (O = i.toArray(b)))
        return f = Rt(f), O.forEach(function(T, v) {
          !(i.isUndefined(T) || T === null) && t.append(a === !0 ? Re([f], v, n) : a === null ? f : f + "[]", l(T));
        }), !1;
    }
    return ve(b) ? !0 : (t.append(Re(m, f, n), l(b)), !1);
  }
  const E = [], g = Object.assign(ls, {
    defaultVisitor: y,
    convertValue: l,
    isVisitable: ve
  });
  function S(b, f, m = 0) {
    if (!i.isUndefined(b)) {
      if (m > c) throw new p("Object is too deeply nested (" + m + " levels). Max depth: " + c, p.ERR_FORM_DATA_DEPTH_EXCEEDED);
      if (E.indexOf(b) !== -1) throw Error("Circular reference detected in " + f.join("."));
      E.push(b), i.forEach(b, function(w, T) {
        (!(i.isUndefined(w) || w === null) && o.call(t, w, i.isString(T) ? T.trim() : T, f, g)) === !0 && S(w, f ? f.concat(T) : [T], m + 1);
      }), E.pop();
    }
  }
  if (!i.isObject(e)) throw new TypeError("data must be an object");
  return S(e), t;
}
function Ve(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(s) {
    return t[s];
  });
}
function _e(e, t) {
  this._pairs = [], e && Ee(e, this, t);
}
var Pt = _e.prototype;
Pt.append = function(t, r) {
  this._pairs.push([t, r]);
};
Pt.toString = function(t) {
  const r = t ? function(s) {
    return t.call(this, s, Ve);
  } : Ve;
  return this._pairs.map(function(o) {
    return r(o[0]) + "=" + r(o[1]);
  }, "").join("&");
};
function ds(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Ct(e, t, r) {
  if (!t) return e;
  const s = r && r.encode || ds, o = i.isFunction(r) ? { serialize: r } : r, n = o && o.serialize;
  let a;
  if (n ? a = n(t, o) : a = i.isURLSearchParams(t) ? t.toString() : new _e(t, o).toString(s), a) {
    const u = e.indexOf("#");
    u !== -1 && (e = e.slice(0, u)), e += (e.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return e;
}
var Ke = class {
  constructor() {
    this.handlers = [];
  }
  use(e, t, r) {
    return this.handlers.push({
      fulfilled: e,
      rejected: t,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  clear() {
    this.handlers && (this.handlers = []);
  }
  forEach(e) {
    i.forEach(this.handlers, function(r) {
      r !== null && e(r);
    });
  }
}, $e = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0
}, hs = typeof URLSearchParams < "u" ? URLSearchParams : _e, fs = typeof FormData < "u" ? FormData : null, ps = typeof Blob < "u" ? Blob : null, ms = {
  isBrowser: !0,
  classes: {
    URLSearchParams: hs,
    FormData: fs,
    Blob: ps
  },
  protocols: [
    "http",
    "https",
    "file",
    "blob",
    "url",
    "data"
  ]
}, ys = /* @__PURE__ */ kt({
  hasBrowserEnv: () => xe,
  hasStandardBrowserEnv: () => bs,
  hasStandardBrowserWebWorkerEnv: () => Es,
  navigator: () => je,
  origin: () => gs
}), xe = typeof window < "u" && typeof document < "u", je = typeof navigator == "object" && navigator || void 0, bs = xe && (!je || [
  "ReactNative",
  "NativeScript",
  "NS"
].indexOf(je.product) < 0), Es = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function", gs = xe && window.location.href || "http://localhost", A = {
  ...ys,
  ...ms
};
function Ts(e, t) {
  return Ee(e, new A.classes.URLSearchParams(), {
    visitor: function(r, s, o, n) {
      return A.isNode && i.isBuffer(r) ? (this.append(s, r.toString("base64")), !1) : n.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function Ss(e) {
  return i.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function ws(e) {
  const t = {}, r = Object.keys(e);
  let s;
  const o = r.length;
  let n;
  for (s = 0; s < o; s++)
    n = r[s], t[n] = e[n];
  return t;
}
function At(e) {
  function t(r, s, o, n) {
    let a = r[n++];
    if (a === "__proto__") return !0;
    const u = Number.isFinite(+a), c = n >= r.length;
    return a = !a && i.isArray(o) ? o.length : a, c ? (i.hasOwnProp(o, a) ? o[a] = i.isArray(o[a]) ? o[a].concat(s) : [o[a], s] : o[a] = s, !u) : ((!o[a] || !i.isObject(o[a])) && (o[a] = []), t(r, s, o[a], n) && i.isArray(o[a]) && (o[a] = ws(o[a])), !u);
  }
  if (i.isFormData(e) && i.isFunction(e.entries)) {
    const r = {};
    return i.forEachEntry(e, (s, o) => {
      t(Ss(s), o, r, 0);
    }), r;
  }
  return null;
}
var K = (e, t) => e != null && i.hasOwnProp(e, t) ? e[t] : void 0;
function Os(e, t, r) {
  if (i.isString(e)) try {
    return (t || JSON.parse)(e), i.trim(e);
  } catch (s) {
    if (s.name !== "SyntaxError") throw s;
  }
  return (r || JSON.stringify)(e);
}
var oe = {
  transitional: $e,
  adapter: [
    "xhr",
    "http",
    "fetch"
  ],
  transformRequest: [function(t, r) {
    const s = r.getContentType() || "", o = s.indexOf("application/json") > -1, n = i.isObject(t);
    if (n && i.isHTMLForm(t) && (t = new FormData(t)), i.isFormData(t)) return o ? JSON.stringify(At(t)) : t;
    if (i.isArrayBuffer(t) || i.isBuffer(t) || i.isStream(t) || i.isFile(t) || i.isBlob(t) || i.isReadableStream(t)) return t;
    if (i.isArrayBufferView(t)) return t.buffer;
    if (i.isURLSearchParams(t))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let a;
    if (n) {
      const u = K(this, "formSerializer");
      if (s.indexOf("application/x-www-form-urlencoded") > -1) return Ts(t, u).toString();
      if ((a = i.isFileList(t)) || s.indexOf("multipart/form-data") > -1) {
        const c = K(this, "env"), d = c && c.FormData;
        return Ee(a ? { "files[]": t } : t, d && new d(), u);
      }
    }
    return n || o ? (r.setContentType("application/json", !1), Os(t)) : t;
  }],
  transformResponse: [function(t) {
    const r = K(this, "transitional") || oe.transitional, s = r && r.forcedJSONParsing, o = K(this, "responseType"), n = o === "json";
    if (i.isResponse(t) || i.isReadableStream(t)) return t;
    if (t && i.isString(t) && (s && !o || n)) {
      const a = !(r && r.silentJSONParsing) && n;
      try {
        return JSON.parse(t, K(this, "parseReviver"));
      } catch (u) {
        if (a)
          throw u.name === "SyntaxError" ? p.from(u, p.ERR_BAD_RESPONSE, this, null, K(this, "response")) : u;
      }
    }
    return t;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: A.classes.FormData,
    Blob: A.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: { common: {
    Accept: "application/json, text/plain, */*",
    "Content-Type": void 0
  } }
};
i.forEach([
  "delete",
  "get",
  "head",
  "post",
  "put",
  "patch",
  "query"
], (e) => {
  oe.headers[e] = {};
});
function Pe(e, t) {
  const r = this || oe, s = t || r, o = q.from(s.headers);
  let n = s.data;
  return i.forEach(e, function(u) {
    n = u.call(r, n, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), n;
}
function qt(e) {
  return !!(e && e.__CANCEL__);
}
var ne = class extends p {
  constructor(e, t, r) {
    super(e ?? "canceled", p.ERR_CANCELED, t, r), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function vt(e, t, r) {
  const s = r.config.validateStatus;
  !r.status || !s || s(r.status) ? e(r) : t(new p("Request failed with status code " + r.status, r.status >= 400 && r.status < 500 ? p.ERR_BAD_REQUEST : p.ERR_BAD_RESPONSE, r.config, r.request, r));
}
function Rs(e) {
  const t = /^([-+\w]{1,25}):(?:\/\/)?/.exec(e);
  return t && t[1] || "";
}
function Ps(e, t) {
  e = e || 10;
  const r = new Array(e), s = new Array(e);
  let o = 0, n = 0, a;
  return t = t !== void 0 ? t : 1e3, function(c) {
    const d = Date.now(), l = s[n];
    a || (a = d), r[o] = c, s[o] = d;
    let y = n, E = 0;
    for (; y !== o; )
      E += r[y++], y = y % e;
    if (o = (o + 1) % e, o === n && (n = (n + 1) % e), d - a < t) return;
    const g = l && d - l;
    return g ? Math.round(E * 1e3 / g) : void 0;
  };
}
function Cs(e, t) {
  let r = 0, s = 1e3 / t, o, n;
  const a = (d, l = Date.now()) => {
    r = l, o = null, n && (clearTimeout(n), n = null), e(...d);
  };
  return [(...d) => {
    const l = Date.now(), y = l - r;
    y >= s ? a(d, l) : (o = d, n || (n = setTimeout(() => {
      n = null, a(o);
    }, s - y)));
  }, () => o && a(o)];
}
var fe = (e, t, r = 3) => {
  let s = 0;
  const o = Ps(50, 250);
  return Cs((n) => {
    const a = n.loaded, u = n.lengthComputable ? n.total : void 0, c = u != null ? Math.min(a, u) : a, d = Math.max(0, c - s), l = o(d);
    s = Math.max(s, c), e({
      loaded: c,
      total: u,
      progress: u ? c / u : void 0,
      bytes: d,
      rate: l || void 0,
      estimated: l && u ? (u - c) / l : void 0,
      event: n,
      lengthComputable: u != null,
      [t ? "download" : "upload"]: !0
    });
  }, r);
}, Xe = (e, t) => {
  const r = e != null;
  return [(s) => t[0]({
    lengthComputable: r,
    total: e,
    loaded: s
  }), t[1]];
}, Qe = (e) => (...t) => i.asap(() => e(...t)), As = A.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (r) => (r = new URL(r, A.origin), e.protocol === r.protocol && e.host === r.host && (t || e.port === r.port)))(new URL(A.origin), A.navigator && /(msie|trident)/i.test(A.navigator.userAgent)) : () => !0, qs = A.hasStandardBrowserEnv ? {
  write(e, t, r, s, o, n, a) {
    if (typeof document > "u") return;
    const u = [`${e}=${encodeURIComponent(t)}`];
    i.isNumber(r) && u.push(`expires=${new Date(r).toUTCString()}`), i.isString(s) && u.push(`path=${s}`), i.isString(o) && u.push(`domain=${o}`), n === !0 && u.push("secure"), i.isString(a) && u.push(`SameSite=${a}`), document.cookie = u.join("; ");
  },
  read(e) {
    if (typeof document > "u") return null;
    const t = document.cookie.split(";");
    for (let r = 0; r < t.length; r++) {
      const s = t[r].replace(/^\s+/, ""), o = s.indexOf("=");
      if (o !== -1 && s.slice(0, o) === e) return decodeURIComponent(s.slice(o + 1));
    }
    return null;
  },
  remove(e) {
    this.write(e, "", Date.now() - 864e5, "/");
  }
} : {
  write() {
  },
  read() {
    return null;
  },
  remove() {
  }
};
function vs(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function js(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function jt(e, t, r) {
  let s = !vs(t);
  return e && (s || r === !1) ? js(e, t) : t;
}
var Ze = (e) => e instanceof q ? { ...e } : e;
function W(e, t) {
  t = t || {};
  const r = /* @__PURE__ */ Object.create(null);
  Object.defineProperty(r, "hasOwnProperty", {
    __proto__: null,
    value: Object.prototype.hasOwnProperty,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
  function s(d, l, y, E) {
    return i.isPlainObject(d) && i.isPlainObject(l) ? i.merge.call({ caseless: E }, d, l) : i.isPlainObject(l) ? i.merge({}, l) : i.isArray(l) ? l.slice() : l;
  }
  function o(d, l, y, E) {
    if (i.isUndefined(l)) {
      if (!i.isUndefined(d)) return s(void 0, d, y, E);
    } else return s(d, l, y, E);
  }
  function n(d, l) {
    if (!i.isUndefined(l)) return s(void 0, l);
  }
  function a(d, l) {
    if (i.isUndefined(l)) {
      if (!i.isUndefined(d)) return s(void 0, d);
    } else return s(void 0, l);
  }
  function u(d, l, y) {
    if (i.hasOwnProp(t, y)) return s(d, l);
    if (i.hasOwnProp(e, y)) return s(void 0, d);
  }
  const c = {
    url: n,
    method: n,
    data: n,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    withXSRFToken: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    beforeRedirect: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    allowedSocketPaths: a,
    responseEncoding: a,
    validateStatus: u,
    headers: (d, l, y) => o(Ze(d), Ze(l), y, !0)
  };
  return i.forEach(Object.keys({
    ...e,
    ...t
  }), function(l) {
    if (l === "__proto__" || l === "constructor" || l === "prototype") return;
    const y = i.hasOwnProp(c, l) ? c[l] : o, E = y(i.hasOwnProp(e, l) ? e[l] : void 0, i.hasOwnProp(t, l) ? t[l] : void 0, l);
    i.isUndefined(E) && y !== u || (r[l] = E);
  }), r;
}
var Ds = ["content-type", "content-length"];
function Ls(e, t, r) {
  if (r !== "content-only") {
    e.set(t);
    return;
  }
  Object.entries(t).forEach(([s, o]) => {
    Ds.includes(s.toLowerCase()) && e.set(s, o);
  });
}
var _s = (e) => encodeURIComponent(e).replace(/%([0-9A-F]{2})/gi, (t, r) => String.fromCharCode(parseInt(r, 16))), Dt = (e) => {
  const t = W({}, e), r = (E) => i.hasOwnProp(t, E) ? t[E] : void 0, s = r("data");
  let o = r("withXSRFToken");
  const n = r("xsrfHeaderName"), a = r("xsrfCookieName");
  let u = r("headers");
  const c = r("auth"), d = r("baseURL"), l = r("allowAbsoluteUrls"), y = r("url");
  if (t.headers = u = q.from(u), t.url = Ct(jt(d, y, l), e.params, e.paramsSerializer), c && u.set("Authorization", "Basic " + btoa((c.username || "") + ":" + (c.password ? _s(c.password) : ""))), i.isFormData(s) && (A.hasStandardBrowserEnv || A.hasStandardBrowserWebWorkerEnv ? u.setContentType(void 0) : i.isFunction(s.getHeaders) && Ls(u, s.getHeaders(), r("formDataHeaderPolicy"))), A.hasStandardBrowserEnv && (i.isFunction(o) && (o = o(t)), o === !0 || o == null && As(t.url))) {
    const E = n && a && qs.read(a);
    E && u.set(n, E);
  }
  return t;
}, $s = typeof XMLHttpRequest < "u", xs = $s && function(e) {
  return new Promise(function(r, s) {
    const o = Dt(e);
    let n = o.data;
    const a = q.from(o.headers).normalize();
    let { responseType: u, onUploadProgress: c, onDownloadProgress: d } = o, l, y, E, g, S;
    function b() {
      g && g(), S && S(), o.cancelToken && o.cancelToken.unsubscribe(l), o.signal && o.signal.removeEventListener("abort", l);
    }
    let f = new XMLHttpRequest();
    f.open(o.method.toUpperCase(), o.url, !0), f.timeout = o.timeout;
    function m() {
      if (!f) return;
      const w = q.from("getAllResponseHeaders" in f && f.getAllResponseHeaders());
      vt(function(v) {
        r(v), b();
      }, function(v) {
        s(v), b();
      }, {
        data: !u || u === "text" || u === "json" ? f.responseText : f.response,
        status: f.status,
        statusText: f.statusText,
        headers: w,
        config: e,
        request: f
      }), f = null;
    }
    "onloadend" in f ? f.onloadend = m : f.onreadystatechange = function() {
      !f || f.readyState !== 4 || f.status === 0 && !(f.responseURL && f.responseURL.startsWith("file:")) || setTimeout(m);
    }, f.onabort = function() {
      f && (s(new p("Request aborted", p.ECONNABORTED, e, f)), b(), f = null);
    }, f.onerror = function(T) {
      const v = new p(T && T.message ? T.message : "Network Error", p.ERR_NETWORK, e, f);
      v.event = T || null, s(v), b(), f = null;
    }, f.ontimeout = function() {
      let T = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const v = o.transitional || $e;
      o.timeoutErrorMessage && (T = o.timeoutErrorMessage), s(new p(T, v.clarifyTimeoutError ? p.ETIMEDOUT : p.ECONNABORTED, e, f)), b(), f = null;
    }, n === void 0 && a.setContentType(null), "setRequestHeader" in f && i.forEach(a.toJSON(), function(T, v) {
      f.setRequestHeader(v, T);
    }), i.isUndefined(o.withCredentials) || (f.withCredentials = !!o.withCredentials), u && u !== "json" && (f.responseType = o.responseType), d && ([E, S] = fe(d, !0), f.addEventListener("progress", E)), c && f.upload && ([y, g] = fe(c), f.upload.addEventListener("progress", y), f.upload.addEventListener("loadend", g)), (o.cancelToken || o.signal) && (l = (w) => {
      f && (s(!w || w.type ? new ne(null, e, f) : w), f.abort(), b(), f = null);
    }, o.cancelToken && o.cancelToken.subscribe(l), o.signal && (o.signal.aborted ? l() : o.signal.addEventListener("abort", l)));
    const O = Rs(o.url);
    if (O && !A.protocols.includes(O)) {
      s(new p("Unsupported protocol " + O + ":", p.ERR_BAD_REQUEST, e));
      return;
    }
    f.send(n || null);
  });
}, Us = (e, t) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (t || r) {
    let s = new AbortController(), o;
    const n = function(d) {
      if (!o) {
        o = !0, u();
        const l = d instanceof Error ? d : this.reason;
        s.abort(l instanceof p ? l : new ne(l instanceof Error ? l.message : l));
      }
    };
    let a = t && setTimeout(() => {
      a = null, n(new p(`timeout of ${t}ms exceeded`, p.ETIMEDOUT));
    }, t);
    const u = () => {
      e && (a && clearTimeout(a), a = null, e.forEach((d) => {
        d.unsubscribe ? d.unsubscribe(n) : d.removeEventListener("abort", n);
      }), e = null);
    };
    e.forEach((d) => d.addEventListener("abort", n));
    const { signal: c } = s;
    return c.unsubscribe = () => i.asap(u), c;
  }
}, Fs = function* (e, t) {
  let r = e.byteLength;
  if (!t || r < t) {
    yield e;
    return;
  }
  let s = 0, o;
  for (; s < r; )
    o = s + t, yield e.slice(s, o), s = o;
}, Ns = async function* (e, t) {
  for await (const r of ks(e)) yield* Fs(r, t);
}, ks = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: s } = await t.read();
      if (r) break;
      yield s;
    }
  } finally {
    await t.cancel();
  }
}, Ye = (e, t, r, s) => {
  const o = Ns(e, t);
  let n = 0, a, u = (c) => {
    a || (a = !0, s && s(c));
  };
  return new ReadableStream({
    async pull(c) {
      try {
        const { done: d, value: l } = await o.next();
        if (d) {
          u(), c.close();
          return;
        }
        let y = l.byteLength;
        r && r(n += y), c.enqueue(new Uint8Array(l));
      } catch (d) {
        throw u(d), d;
      }
    },
    cancel(c) {
      return u(c), o.return();
    }
  }, { highWaterMark: 2 });
};
function Is(e) {
  if (!e || typeof e != "string" || !e.startsWith("data:")) return 0;
  const t = e.indexOf(",");
  if (t < 0) return 0;
  const r = e.slice(5, t), s = e.slice(t + 1);
  if (/;base64/i.test(r)) {
    let n = s.length;
    const a = s.length;
    for (let y = 0; y < a; y++) if (s.charCodeAt(y) === 37 && y + 2 < a) {
      const E = s.charCodeAt(y + 1), g = s.charCodeAt(y + 2);
      (E >= 48 && E <= 57 || E >= 65 && E <= 70 || E >= 97 && E <= 102) && (g >= 48 && g <= 57 || g >= 65 && g <= 70 || g >= 97 && g <= 102) && (n -= 2, y += 2);
    }
    let u = 0, c = a - 1;
    const d = (y) => y >= 2 && s.charCodeAt(y - 2) === 37 && s.charCodeAt(y - 1) === 51 && (s.charCodeAt(y) === 68 || s.charCodeAt(y) === 100);
    c >= 0 && (s.charCodeAt(c) === 61 ? (u++, c--) : d(c) && (u++, c -= 3)), u === 1 && c >= 0 && (s.charCodeAt(c) === 61 || d(c)) && u++;
    const l = Math.floor(n / 4) * 3 - (u || 0);
    return l > 0 ? l : 0;
  }
  if (typeof Buffer < "u" && typeof Buffer.byteLength == "function") return Buffer.byteLength(s, "utf8");
  let o = 0;
  for (let n = 0, a = s.length; n < a; n++) {
    const u = s.charCodeAt(n);
    if (u < 128) o += 1;
    else if (u < 2048) o += 2;
    else if (u >= 55296 && u <= 56319 && n + 1 < a) {
      const c = s.charCodeAt(n + 1);
      c >= 56320 && c <= 57343 ? (o += 4, n++) : o += 3;
    } else o += 3;
  }
  return o;
}
var Ue = "1.16.0", et = 64 * 1024, { isFunction: ce } = i, tt = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, Bs = (e) => {
  const t = i.global ?? globalThis, { ReadableStream: r, TextEncoder: s } = t;
  e = i.merge.call({ skipUndefined: !0 }, {
    Request: t.Request,
    Response: t.Response
  }, e);
  const { fetch: o, Request: n, Response: a } = e, u = o ? ce(o) : typeof fetch == "function", c = ce(n), d = ce(a);
  if (!u) return !1;
  const l = u && ce(r), y = u && (typeof s == "function" ? /* @__PURE__ */ ((m) => (O) => m.encode(O))(new s()) : async (m) => new Uint8Array(await new n(m).arrayBuffer())), E = c && l && tt(() => {
    let m = !1;
    const O = new n(A.origin, {
      body: new r(),
      method: "POST",
      get duplex() {
        return m = !0, "half";
      }
    }), w = O.headers.has("Content-Type");
    return O.body != null && O.body.cancel(), m && !w;
  }), g = d && l && tt(() => i.isReadableStream(new a("").body)), S = { stream: g && ((m) => m.body) };
  u && [
    "text",
    "arrayBuffer",
    "blob",
    "formData",
    "stream"
  ].forEach((m) => {
    !S[m] && (S[m] = (O, w) => {
      let T = O && O[m];
      if (T) return T.call(O);
      throw new p(`Response type '${m}' is not supported`, p.ERR_NOT_SUPPORT, w);
    });
  });
  const b = async (m) => {
    if (m == null) return 0;
    if (i.isBlob(m)) return m.size;
    if (i.isSpecCompliantForm(m)) return (await new n(A.origin, {
      method: "POST",
      body: m
    }).arrayBuffer()).byteLength;
    if (i.isArrayBufferView(m) || i.isArrayBuffer(m)) return m.byteLength;
    if (i.isURLSearchParams(m) && (m = m + ""), i.isString(m)) return (await y(m)).byteLength;
  }, f = async (m, O) => {
    const w = i.toFiniteNumber(m.getContentLength());
    return w ?? b(O);
  };
  return async (m) => {
    let { url: O, method: w, data: T, signal: v, cancelToken: Ne, timeout: Ut, onDownloadProgress: Te, onUploadProgress: ke, responseType: k, headers: J, withCredentials: ae = "same-origin", fetchOptions: Ie, maxContentLength: U, maxBodyLength: Se } = Dt(m);
    const Z = i.isNumber(U) && U > -1, Ft = i.isNumber(Se) && Se > -1;
    let Be = o || fetch;
    k = k ? (k + "").toLowerCase() : "text";
    let I = Us([v, Ne && Ne.toAbortSignal()], Ut), L = null;
    const H = I && I.unsubscribe && (() => {
      I.unsubscribe();
    });
    let Je;
    try {
      if (Z && typeof O == "string" && O.startsWith("data:") && Is(O) > U)
        throw new p("maxContentLength size of " + U + " exceeded", p.ERR_BAD_RESPONSE, m, L);
      if (Ft && w !== "get" && w !== "head") {
        const R = await f(J, T);
        if (typeof R == "number" && isFinite(R) && R > Se) throw new p("Request body larger than maxBodyLength limit", p.ERR_BAD_REQUEST, m, L);
      }
      if (ke && E && w !== "get" && w !== "head" && (Je = await f(J, T)) !== 0) {
        let R = new n(O, {
          method: "POST",
          body: T,
          duplex: "half"
        }), V;
        if (i.isFormData(T) && (V = R.headers.get("content-type")) && J.setContentType(V), R.body) {
          const [ie, ue] = Xe(Je, fe(Qe(ke)));
          T = Ye(R.body, et, ie, ue);
        }
      }
      i.isString(ae) || (ae = ae ? "include" : "omit");
      const C = c && "credentials" in n.prototype;
      if (i.isFormData(T)) {
        const R = J.getContentType();
        R && /^multipart\/form-data/i.test(R) && !/boundary=/i.test(R) && J.delete("content-type");
      }
      J.set("User-Agent", "axios/" + Ue, !1);
      const B = {
        ...Ie,
        signal: I,
        method: w.toUpperCase(),
        headers: J.normalize().toJSON(),
        body: T,
        duplex: "half",
        credentials: C ? ae : void 0
      };
      L = c && new n(O, B);
      let F = await (c ? Be(L, Ie) : Be(O, B));
      if (Z) {
        const R = i.toFiniteNumber(F.headers.get("content-length"));
        if (R != null && R > U) throw new p("maxContentLength size of " + U + " exceeded", p.ERR_BAD_RESPONSE, m, L);
      }
      const we = g && (k === "stream" || k === "response");
      if (g && F.body && (Te || Z || we && H)) {
        const R = {};
        [
          "status",
          "statusText",
          "headers"
        ].forEach((Y) => {
          R[Y] = F[Y];
        });
        const V = i.toFiniteNumber(F.headers.get("content-length")), [ie, ue] = Te && Xe(V, fe(Qe(Te), !0)) || [];
        let He = 0;
        const Nt = (Y) => {
          if (Z && (He = Y, He > U))
            throw new p("maxContentLength size of " + U + " exceeded", p.ERR_BAD_RESPONSE, m, L);
          ie && ie(Y);
        };
        F = new a(Ye(F.body, et, Nt, () => {
          ue && ue(), H && H();
        }), R);
      }
      k = k || "text";
      let N = await S[i.findKey(S, k) || "text"](F, m);
      if (Z && !g && !we) {
        let R;
        if (N != null && (typeof N.byteLength == "number" ? R = N.byteLength : typeof N.size == "number" ? R = N.size : typeof N == "string" && (R = typeof s == "function" ? new s().encode(N).byteLength : N.length)), typeof R == "number" && R > U) throw new p("maxContentLength size of " + U + " exceeded", p.ERR_BAD_RESPONSE, m, L);
      }
      return !we && H && H(), await new Promise((R, V) => {
        vt(R, V, {
          data: N,
          headers: q.from(F.headers),
          status: F.status,
          statusText: F.statusText,
          config: m,
          request: L
        });
      });
    } catch (C) {
      if (H && H(), I && I.aborted && I.reason instanceof p) {
        const B = I.reason;
        throw B.config = m, L && (B.request = L), C !== B && (B.cause = C), B;
      }
      throw C && C.name === "TypeError" && /Load failed|fetch/i.test(C.message) ? Object.assign(new p("Network Error", p.ERR_NETWORK, m, L, C && C.response), { cause: C.cause || C }) : p.from(C, C && C.code, m, L, C && C.response);
    }
  };
}, Js = /* @__PURE__ */ new Map(), Lt = (e) => {
  let t = e && e.env || {};
  const { fetch: r, Request: s, Response: o } = t, n = [
    s,
    o,
    r
  ];
  let a = n.length, u, c, d = Js;
  for (; a--; )
    u = n[a], c = d.get(u), c === void 0 && d.set(u, c = a ? /* @__PURE__ */ new Map() : Bs(t)), d = c;
  return c;
}, jo = Lt(), Fe = {
  http: null,
  xhr: xs,
  fetch: { get: Lt }
};
i.forEach(Fe, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", {
        __proto__: null,
        value: t
      });
    } catch {
    }
    Object.defineProperty(e, "adapterName", {
      __proto__: null,
      value: t
    });
  }
});
var rt = (e) => `- ${e}`, Hs = (e) => i.isFunction(e) || e === null || e === !1;
function Ms(e, t) {
  e = i.isArray(e) ? e : [e];
  const { length: r } = e;
  let s, o;
  const n = {};
  for (let a = 0; a < r; a++) {
    s = e[a];
    let u;
    if (o = s, !Hs(s) && (o = Fe[(u = String(s)).toLowerCase()], o === void 0))
      throw new p(`Unknown adapter '${u}'`);
    if (o && (i.isFunction(o) || (o = o.get(t)))) break;
    n[u || "#" + a] = o;
  }
  if (!o) {
    const a = Object.entries(n).map(([u, c]) => `adapter ${u} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build"));
    throw new p("There is no suitable adapter to dispatch the request " + (r ? a.length > 1 ? `since :
` + a.map(rt).join(`
`) : " " + rt(a[0]) : "as no adapter specified"), "ERR_NOT_SUPPORT");
  }
  return o;
}
var _t = {
  getAdapter: Ms,
  adapters: Fe
};
function Ce(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted) throw new ne(null, e);
}
function st(e) {
  return Ce(e), e.headers = q.from(e.headers), e.data = Pe.call(e, e.transformRequest), [
    "post",
    "put",
    "patch"
  ].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), _t.getAdapter(e.adapter || oe.adapter, e)(e).then(function(r) {
    Ce(e), e.response = r;
    try {
      r.data = Pe.call(e, e.transformResponse, r);
    } finally {
      delete e.response;
    }
    return r.headers = q.from(r.headers), r;
  }, function(r) {
    if (!qt(r) && (Ce(e), r && r.response)) {
      e.response = r.response;
      try {
        r.response.data = Pe.call(e, e.transformResponse, r.response);
      } finally {
        delete e.response;
      }
      r.response.headers = q.from(r.response.headers);
    }
    return Promise.reject(r);
  });
}
var ge = {};
[
  "object",
  "boolean",
  "number",
  "function",
  "string",
  "symbol"
].forEach((e, t) => {
  ge[e] = function(s) {
    return typeof s === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
var ot = {};
ge.transitional = function(t, r, s) {
  function o(n, a) {
    return "[Axios v" + Ue + "] Transitional option '" + n + "'" + a + (s ? ". " + s : "");
  }
  return (n, a, u) => {
    if (t === !1) throw new p(o(a, " has been removed" + (r ? " in " + r : "")), p.ERR_DEPRECATED);
    return r && !ot[a] && (ot[a] = !0, console.warn(o(a, " has been deprecated since v" + r + " and will be removed in the near future"))), t ? t(n, a, u) : !0;
  };
};
ge.spelling = function(t) {
  return (r, s) => (console.warn(`${s} is likely a misspelling of ${t}`), !0);
};
function Gs(e, t, r) {
  if (typeof e != "object") throw new p("options must be an object", p.ERR_BAD_OPTION_VALUE);
  const s = Object.keys(e);
  let o = s.length;
  for (; o-- > 0; ) {
    const n = s[o], a = Object.prototype.hasOwnProperty.call(t, n) ? t[n] : void 0;
    if (a) {
      const u = e[n], c = u === void 0 || a(u, n, e);
      if (c !== !0) throw new p("option " + n + " must be " + c, p.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0) throw new p("Unknown option " + n, p.ERR_BAD_OPTION);
  }
}
var he = {
  assertOptions: Gs,
  validators: ge
}, _ = he.validators, G = class {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = {
      request: new Ke(),
      response: new Ke()
    };
  }
  async request(e, t) {
    try {
      return await this._request(e, t);
    } catch (r) {
      if (r instanceof Error) {
        let s = {};
        Error.captureStackTrace ? Error.captureStackTrace(s) : s = /* @__PURE__ */ new Error();
        const o = (() => {
          if (!s.stack) return "";
          const n = s.stack.indexOf(`
`);
          return n === -1 ? "" : s.stack.slice(n + 1);
        })();
        try {
          if (!r.stack) r.stack = o;
          else if (o) {
            const n = o.indexOf(`
`), a = n === -1 ? -1 : o.indexOf(`
`, n + 1), u = a === -1 ? "" : o.slice(a + 1);
            String(r.stack).endsWith(u) || (r.stack += `
` + o);
          }
        } catch {
        }
      }
      throw r;
    }
  }
  _request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = W(this.defaults, t);
    const { transitional: r, paramsSerializer: s, headers: o } = t;
    r !== void 0 && he.assertOptions(r, {
      silentJSONParsing: _.transitional(_.boolean),
      forcedJSONParsing: _.transitional(_.boolean),
      clarifyTimeoutError: _.transitional(_.boolean),
      legacyInterceptorReqResOrdering: _.transitional(_.boolean)
    }, !1), s != null && (i.isFunction(s) ? t.paramsSerializer = { serialize: s } : he.assertOptions(s, {
      encode: _.function,
      serialize: _.function
    }, !0)), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : t.allowAbsoluteUrls = !0), he.assertOptions(t, {
      baseUrl: _.spelling("baseURL"),
      withXsrfToken: _.spelling("withXSRFToken")
    }, !0), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let n = o && i.merge(o.common, o[t.method]);
    o && i.forEach([
      "delete",
      "get",
      "head",
      "post",
      "put",
      "patch",
      "query",
      "common"
    ], (g) => {
      delete o[g];
    }), t.headers = q.concat(n, o);
    const a = [];
    let u = !0;
    this.interceptors.request.forEach(function(S) {
      if (typeof S.runWhen == "function" && S.runWhen(t) === !1) return;
      u = u && S.synchronous;
      const b = t.transitional || $e;
      b && b.legacyInterceptorReqResOrdering ? a.unshift(S.fulfilled, S.rejected) : a.push(S.fulfilled, S.rejected);
    });
    const c = [];
    this.interceptors.response.forEach(function(S) {
      c.push(S.fulfilled, S.rejected);
    });
    let d, l = 0, y;
    if (!u) {
      const g = [st.bind(this), void 0];
      for (g.unshift(...a), g.push(...c), y = g.length, d = Promise.resolve(t); l < y; ) d = d.then(g[l++], g[l++]);
      return d;
    }
    y = a.length;
    let E = t;
    for (; l < y; ) {
      const g = a[l++], S = a[l++];
      try {
        E = g(E);
      } catch (b) {
        S.call(this, b);
        break;
      }
    }
    try {
      d = st.call(this, E);
    } catch (g) {
      return Promise.reject(g);
    }
    for (l = 0, y = c.length; l < y; ) d = d.then(c[l++], c[l++]);
    return d;
  }
  getUri(e) {
    return e = W(this.defaults, e), Ct(jt(e.baseURL, e.url, e.allowAbsoluteUrls), e.params, e.paramsSerializer);
  }
};
i.forEach([
  "delete",
  "get",
  "head",
  "options"
], function(t) {
  G.prototype[t] = function(r, s) {
    return this.request(W(s || {}, {
      method: t,
      url: r,
      data: (s || {}).data
    }));
  };
});
i.forEach([
  "post",
  "put",
  "patch",
  "query"
], function(t) {
  function r(s) {
    return function(n, a, u) {
      return this.request(W(u || {}, {
        method: t,
        headers: s ? { "Content-Type": "multipart/form-data" } : {},
        url: n,
        data: a
      }));
    };
  }
  G.prototype[t] = r(), t !== "query" && (G.prototype[t + "Form"] = r(!0));
});
var zs = class $t {
  constructor(t) {
    if (typeof t != "function") throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(n) {
      r = n;
    });
    const s = this;
    this.promise.then((o) => {
      if (!s._listeners) return;
      let n = s._listeners.length;
      for (; n-- > 0; ) s._listeners[n](o);
      s._listeners = null;
    }), this.promise.then = (o) => {
      let n;
      const a = new Promise((u) => {
        s.subscribe(u), n = u;
      }).then(o);
      return a.cancel = function() {
        s.unsubscribe(n);
      }, a;
    }, t(function(n, a, u) {
      s.reason || (s.reason = new ne(n, a, u), r(s.reason));
    });
  }
  throwIfRequested() {
    if (this.reason) throw this.reason;
  }
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  unsubscribe(t) {
    if (!this._listeners) return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), r = (s) => {
      t.abort(s);
    };
    return this.subscribe(r), t.signal.unsubscribe = () => this.unsubscribe(r), t.signal;
  }
  static source() {
    let t;
    return {
      token: new $t(function(s) {
        t = s;
      }),
      cancel: t
    };
  }
};
function Ws(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function Vs(e) {
  return i.isObject(e) && e.isAxiosError === !0;
}
var De = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(De).forEach(([e, t]) => {
  De[t] = e;
});
function xt(e) {
  const t = new G(e), r = mt(G.prototype.request, t);
  return i.extend(r, G.prototype, t, { allOwnKeys: !0 }), i.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(o) {
    return xt(W(e, o));
  }, r;
}
var P = xt(oe);
P.Axios = G;
P.CanceledError = ne;
P.CancelToken = zs;
P.isCancel = qt;
P.VERSION = Ue;
P.toFormData = Ee;
P.AxiosError = p;
P.Cancel = P.CanceledError;
P.all = function(t) {
  return Promise.all(t);
};
P.spread = Ws;
P.isAxiosError = Vs;
P.mergeConfig = W;
P.AxiosHeaders = q;
P.formToJSON = (e) => At(i.isHTMLForm(e) ? new FormData(e) : e);
P.getAdapter = _t.getAdapter;
P.HttpStatusCode = De;
P.default = P;
var h = /* @__PURE__ */ (function(e) {
  return e.Json = "application/json", e.JsonApi = "application/vnd.api+json", e.FormData = "multipart/form-data", e.UrlEncoded = "application/x-www-form-urlencoded", e.Text = "text/plain", e;
})({}), D = class {
  instance;
  securityData = null;
  securityWorker;
  secure;
  format;
  constructor({ securityWorker: e, secure: t, format: r, ...s } = {}) {
    this.instance = P.create({
      ...s,
      baseURL: s.baseURL || ""
    }), this.secure = t, this.format = r, this.securityWorker = e;
  }
  setSecurityData = (e) => {
    this.securityData = e;
  };
  mergeRequestParams(e, t) {
    const r = e.method || t && t.method;
    return {
      ...this.instance.defaults,
      ...e,
      ...t || {},
      headers: {
        ...r && this.instance.defaults.headers[r.toLowerCase()] || {},
        ...e.headers || {},
        ...t && t.headers || {}
      }
    };
  }
  stringifyFormItem(e) {
    return typeof e == "object" && e !== null ? JSON.stringify(e) : `${e}`;
  }
  createFormData(e) {
    return e instanceof FormData ? e : Object.keys(e || {}).reduce((t, r) => {
      const s = e[r];
      if (s == null) return t;
      const o = s instanceof Array ? s : [s];
      for (const n of o) {
        if (n == null) continue;
        const a = n instanceof Blob || n instanceof File;
        t.append(r, a ? n : this.stringifyFormItem(n));
      }
      return t;
    }, new FormData());
  }
  request = async ({ secure: e, path: t, type: r, query: s, format: o, body: n, ...a }) => {
    const u = (typeof e == "boolean" ? e : this.secure) && this.securityWorker && await this.securityWorker(this.securityData) || {}, c = this.mergeRequestParams(a, u), d = o || this.format || void 0;
    return r === h.FormData && n && n !== null && typeof n == "object" && (n = this.createFormData(n)), r === h.Text && n && n !== null && typeof n != "string" && (n = JSON.stringify(n)), this.instance.request({
      ...c,
      headers: {
        ...c.headers || {},
        ...r ? { "Content-Type": r } : {}
      },
      params: s,
      responseType: d,
      data: n,
      url: t
    });
  };
}, Do = class extends D {
  assetsList = (e, t = {}) => this.request({
    path: "/assets",
    method: "GET",
    query: e,
    secure: !0,
    format: "json",
    ...t
  });
  assetsCreate = (e, t = {}) => this.request({
    path: "/assets",
    method: "POST",
    body: e,
    secure: !0,
    type: h.FormData,
    format: "json",
    ...t
  });
  filesCreate = (e, t, r = {}) => this.request({
    path: `/assets/${e}/files`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.FormData,
    format: "json",
    ...r
  });
  historyList = (e, t = {}) => this.request({
    path: `/assets/${e}/history`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  rollbackCreate = (e, t, r = {}) => this.request({
    path: `/assets/${e}/rollback`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.Json,
    format: "json",
    ...r
  });
  assetsDetail = (e, t = {}) => this.request({
    path: `/assets/${e}`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  assetsPartialUpdate = (e, t, r = {}) => this.request({
    path: `/assets/${e}`,
    method: "PATCH",
    body: t,
    secure: !0,
    type: h.FormData,
    format: "json",
    ...r
  });
  assetsDelete = (e, t, r = {}) => this.request({
    path: `/assets/${e}`,
    method: "DELETE",
    body: t,
    secure: !0,
    type: h.Json,
    ...r
  });
  fileList = (e, t = {}) => this.request({
    path: `/assets/${e}/file`,
    method: "GET",
    secure: !0,
    ...t
  });
  filesDetail = (e, t, r = {}) => this.request({
    path: `/assets/${e}/files/${t}`,
    method: "GET",
    secure: !0,
    ...r
  });
  swapPartialUpdate = (e, t, r = {}) => this.request({
    path: `/assets/${e}/swap/${t}`,
    method: "PATCH",
    secure: !0,
    format: "json",
    ...r
  });
  copyCreate = (e, t, r = {}) => this.request({
    path: `/assets/${e}/copy`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.Json,
    format: "json",
    ...r
  });
  copiesList = (e, t, r = {}) => this.request({
    path: `/assets/${e}/copies`,
    method: "GET",
    query: t,
    secure: !0,
    format: "json",
    ...r
  });
  transferCreate = (e, t, r = {}) => this.request({
    path: `/assets/${e}/transfer`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.Json,
    ...r
  });
  orderPartialUpdate = (e, t = {}) => this.request({
    path: "/assets/order",
    method: "PATCH",
    body: e,
    secure: !0,
    type: h.Json,
    ...t
  });
  kindsList = (e = {}) => this.request({
    path: "/assets/kinds",
    method: "GET",
    secure: !0,
    format: "json",
    ...e
  });
  tagsCreate = (e, t = {}) => this.request({
    path: "/assets/tags",
    method: "POST",
    body: e,
    secure: !0,
    type: h.FormData,
    ...t
  });
  tagsList = (e, t = {}) => this.request({
    path: "/assets/tags",
    method: "GET",
    query: e,
    secure: !0,
    format: "json",
    ...t
  });
  tagsPartialUpdate = (e, t, r = {}) => this.request({
    path: `/assets/tags/${e}`,
    method: "PATCH",
    body: t,
    secure: !0,
    type: h.FormData,
    ...r
  });
  tagsDetail = (e, t = {}) => this.request({
    path: `/assets/tags/${e}`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  tagsDelete = (e, t = {}) => this.request({
    path: `/assets/tags/${e}`,
    method: "DELETE",
    secure: !0,
    ...t
  });
}, Lo = class extends D {
  loginCreate = (e, t = {}) => this.request({
    path: "/auth/login",
    method: "POST",
    body: e,
    secure: !0,
    type: h.Json,
    format: "json",
    ...t
  });
  loginGuestCreate = (e = {}) => this.request({
    path: "/auth/login/guest",
    method: "POST",
    secure: !0,
    format: "json",
    ...e
  });
  loginGoogleCreate = (e, t = {}) => this.request({
    path: "/auth/login/google",
    method: "POST",
    query: e,
    secure: !0,
    format: "json",
    ...t
  });
  loginAppleCreate = (e, t = {}) => this.request({
    path: "/auth/login/apple",
    method: "POST",
    query: e,
    secure: !0,
    format: "json",
    ...t
  });
  logoutCreate = (e, t, r = {}) => this.request({
    path: "/auth/logout",
    method: "POST",
    query: t,
    body: e,
    secure: !0,
    type: h.Json,
    ...r
  });
  logoutAllCreate = (e = {}) => this.request({
    path: "/auth/logout/all",
    method: "POST",
    secure: !0,
    ...e
  });
  registerCreate = (e, t = {}) => this.request({
    path: "/auth/register",
    method: "POST",
    body: e,
    secure: !0,
    type: h.Json,
    ...t
  });
  confirmEmailList = (e, t = {}) => this.request({
    path: "/auth/confirm-email",
    method: "GET",
    query: e,
    secure: !0,
    ...t
  });
  checkEmailCreate = (e, t = {}) => this.request({
    path: "/auth/check-email",
    method: "POST",
    query: e,
    secure: !0,
    format: "json",
    ...t
  });
  resendEmailCreate = (e, t = {}) => this.request({
    path: "/auth/resend-email",
    method: "POST",
    query: e,
    secure: !0,
    ...t
  });
  sendResetPasswordEmailCreate = (e, t = {}) => this.request({
    path: "/auth/send-reset-password-email",
    method: "POST",
    body: e,
    secure: !0,
    type: h.Json,
    ...t
  });
  inviteCreate = (e, t = {}) => this.request({
    path: "/auth/invite",
    method: "POST",
    body: e,
    secure: !0,
    type: h.Json,
    ...t
  });
  updatePasswordCreate = (e, t = {}) => this.request({
    path: "/auth/update-password",
    method: "POST",
    body: e,
    secure: !0,
    type: h.Json,
    ...t
  });
  resetPasswordCreate = (e, t = {}) => this.request({
    path: "/auth/reset-password",
    method: "POST",
    body: e,
    secure: !0,
    type: h.Json,
    ...t
  });
  tokenRefreshCreate = (e, t = {}) => this.request({
    path: "/auth/token/refresh",
    method: "POST",
    body: e,
    secure: !0,
    type: h.UrlEncoded,
    format: "json",
    ...t
  });
  impersonateCreate = (e, t = {}) => this.request({
    path: "/auth/impersonate",
    method: "POST",
    body: e,
    secure: !0,
    type: h.Json,
    format: "json",
    ...t
  });
}, _o = class extends D {
  avatarsList = (e = {}) => this.request({
    path: "/avatars",
    method: "GET",
    secure: !0,
    format: "json",
    ...e
  });
  avatarsCreate = (e, t = {}) => this.request({
    path: "/avatars",
    method: "POST",
    body: e,
    secure: !0,
    type: h.Json,
    format: "json",
    ...t
  });
}, $o = class extends D {
  categoriesList = (e = {}) => this.request({
    path: "/catalogs/categories",
    method: "GET",
    secure: !0,
    format: "json",
    ...e
  });
  categoriesCreate = (e, t = {}) => this.request({
    path: "/catalogs/categories",
    method: "POST",
    body: e,
    secure: !0,
    type: h.Json,
    format: "json",
    ...t
  });
  categoriesDetail = (e, t = {}) => this.request({
    path: `/catalogs/categories/${e}`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  categoriesDelete = (e, t = {}) => this.request({
    path: `/catalogs/categories/${e}`,
    method: "DELETE",
    secure: !0,
    ...t
  });
  categoriesPartialUpdate = (e, t, r = {}) => this.request({
    path: `/catalogs/categories/${e}`,
    method: "PATCH",
    body: t,
    secure: !0,
    type: h.Json,
    format: "json",
    ...r
  });
  packsList = (e = {}) => this.request({
    path: "/catalogs/packs",
    method: "GET",
    secure: !0,
    format: "json",
    ...e
  });
  packsCreate = (e, t = {}) => this.request({
    path: "/catalogs/packs",
    method: "POST",
    body: e,
    secure: !0,
    type: h.FormData,
    format: "json",
    ...t
  });
  packsPagedList = (e, t = {}) => this.request({
    path: "/catalogs/packs/paged",
    method: "GET",
    query: e,
    secure: !0,
    format: "json",
    ...t
  });
  categoriesPacksList = (e, t = {}) => this.request({
    path: `/catalogs/categories/${e}/packs`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  packsPartialUpdate = (e, t, r = {}) => this.request({
    path: `/catalogs/packs/${e}`,
    method: "PATCH",
    body: t,
    secure: !0,
    type: h.FormData,
    format: "json",
    ...r
  });
  packsDetail = (e, t = {}) => this.request({
    path: `/catalogs/packs/${e}`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  packsDelete = (e, t = {}) => this.request({
    path: `/catalogs/packs/${e}`,
    method: "DELETE",
    secure: !0,
    ...t
  });
  assetsDetail = (e, t = {}) => this.request({
    path: `/catalogs/assets/${e}`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  assetsPartialUpdate = (e, t, r = {}) => this.request({
    path: `/catalogs/assets/${e}`,
    method: "PATCH",
    body: t,
    secure: !0,
    type: h.Json,
    format: "json",
    ...r
  });
  assetsDelete = (e, t = {}) => this.request({
    path: `/catalogs/assets/${e}`,
    method: "DELETE",
    secure: !0,
    ...t
  });
  assetsCreate = (e, t = {}) => this.request({
    path: "/catalogs/assets",
    method: "POST",
    body: e,
    secure: !0,
    type: h.FormData,
    format: "json",
    ...t
  });
  createPackFromFolderCreate = (e, t, r = {}) => this.request({
    path: `/catalogs/create-pack-from-folder/${e}`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.FormData,
    ...r
  });
}, xo = class extends D {
  codeDetail = (e, t = {}) => this.request({
    path: `/code/${e}`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
}, Uo = class extends D {
  contactusCreate = (e, t = {}) => this.request({
    path: "/contactus",
    method: "POST",
    body: e,
    secure: !0,
    type: h.FormData,
    ...t
  });
}, Fo = class extends D {
  experiencesList = (e, t = {}) => this.request({
    path: "/experiences",
    method: "GET",
    query: e,
    secure: !0,
    format: "json",
    ...t
  });
}, No = class extends D {
  foldersCreate = (e, t = {}) => this.request({
    path: "/folders",
    method: "POST",
    body: e,
    secure: !0,
    type: h.Json,
    format: "json",
    ...t
  });
  foldersPartialUpdate = (e, t, r = {}) => this.request({
    path: `/folders/${e}`,
    method: "PATCH",
    body: t,
    secure: !0,
    type: h.Json,
    ...r
  });
  foldersDelete = (e, t, r = {}) => this.request({
    path: `/folders/${e}`,
    method: "DELETE",
    body: t,
    secure: !0,
    type: h.Json,
    ...r
  });
  foldersDetail = (e, t = {}) => this.request({
    path: `/folders/${e}`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  transferCreate = (e, t, r = {}) => this.request({
    path: `/folders/${e}/transfer`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.Json,
    ...r
  });
  assetsList = (e, t = {}) => this.request({
    path: `/folders/${e}/assets`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  membersList = (e, t = {}) => this.request({
    path: `/folders/${e}/members`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  membersTeamsCreate = (e, t, r = {}) => this.request({
    path: `/folders/${e}/members/teams`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.Json,
    ...r
  });
  membersUsersCreate = (e, t, r = {}) => this.request({
    path: `/folders/${e}/members/users`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.Json,
    ...r
  });
}, ko = class extends D {
  projectsList = (e, t = {}) => this.request({
    path: "/projects",
    method: "GET",
    query: e,
    secure: !0,
    format: "json",
    ...t
  });
  projectsCreate = (e, t = {}) => this.request({
    path: "/projects",
    method: "POST",
    body: e,
    secure: !0,
    type: h.FormData,
    format: "json",
    ...t
  });
  projectsPartialUpdate = (e, t, r = {}) => this.request({
    path: `/projects/${e}`,
    method: "PATCH",
    body: t,
    secure: !0,
    type: h.FormData,
    format: "json",
    ...r
  });
  projectsDelete = (e, t, r = {}) => this.request({
    path: `/projects/${e}`,
    method: "DELETE",
    body: t,
    secure: !0,
    type: h.Json,
    ...r
  });
  projectsDetail = (e, t = {}) => this.request({
    path: `/projects/${e}`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  transferCreate = (e, t, r = {}) => this.request({
    path: `/projects/${e}/transfer`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.Json,
    ...r
  });
  scenesList = (e, t = {}) => this.request({
    path: `/projects/${e}/scenes`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  scenesPartialUpdate = (e, t, r = {}) => this.request({
    path: `/projects/${e}/scenes`,
    method: "PATCH",
    body: t,
    secure: !0,
    type: h.FormData,
    format: "json",
    ...r
  });
  scenesPartialUpdate2 = (e, t, r, s = {}) => this.request({
    path: `/projects/${e}/scenes/${t}`,
    method: "PATCH",
    body: r,
    secure: !0,
    type: h.Json,
    ...s
  });
  scenesDelete = (e, t, r, s = {}) => this.request({
    path: `/projects/${t}/scenes/${e}`,
    method: "DELETE",
    body: r,
    secure: !0,
    type: h.FormData,
    ...s
  });
  scenesUploadCreate = (e, t, r = {}) => this.request({
    path: `/projects/${e}/scenes/upload`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.FormData,
    format: "json",
    ...r
  });
  announcementsList = (e = {}) => this.request({
    path: "/projects/announcements",
    method: "GET",
    secure: !0,
    format: "json",
    ...e
  });
  accessorsList = (e, t = {}) => this.request({
    path: `/projects/${e}/accessors`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  accessorsCreate = (e, t, r = {}) => this.request({
    path: `/projects/${e}/accessors`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.Json,
    format: "json",
    ...r
  });
  accessorsUpdate = (e, t, r = {}) => this.request({
    path: `/projects/${e}/accessors`,
    method: "PUT",
    body: t,
    secure: !0,
    type: h.Json,
    format: "json",
    ...r
  });
  accessorsPartialUpdate = (e, t, r, s = {}) => this.request({
    path: `/projects/${e}/accessors/${t}`,
    method: "PATCH",
    body: r,
    secure: !0,
    type: h.Json,
    format: "json",
    ...s
  });
  accessorsDelete = (e, t, r = {}) => this.request({
    path: `/projects/${e}/accessors/${t}`,
    method: "DELETE",
    secure: !0,
    ...r
  });
  accessorsDetail = (e, t, r = {}) => this.request({
    path: `/projects/${e}/accessors/${t}`,
    method: "GET",
    secure: !0,
    format: "json",
    ...r
  });
  membersList = (e, t = {}) => this.request({
    path: `/projects/${e}/members`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  membersTeamsCreate = (e, t, r = {}) => this.request({
    path: `/projects/${e}/members/teams`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.Json,
    ...r
  });
  membersUsersCreate = (e, t, r = {}) => this.request({
    path: `/projects/${e}/members/users`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.Json,
    ...r
  });
  foldersCreate = (e, t, r = {}) => this.request({
    path: `/projects/${e}/folders`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.Json,
    format: "json",
    ...r
  });
  foldersPartialUpdate = (e, t, r, s = {}) => this.request({
    path: `/projects/${e}/folders/${t}`,
    method: "PATCH",
    body: r,
    secure: !0,
    type: h.Json,
    format: "json",
    ...s
  });
  foldersDetail = (e, t, r = {}) => this.request({
    path: `/projects/${e}/folders/${t}`,
    method: "GET",
    secure: !0,
    format: "json",
    ...r
  });
  foldersDelete = (e, t, r = {}) => this.request({
    path: `/projects/${e}/folders/${t}`,
    method: "DELETE",
    secure: !0,
    format: "json",
    ...r
  });
  foldersScenesPartialUpdate = (e, t, r, s = {}) => this.request({
    path: `/projects/${e}/folders/${t}/scenes/${r}`,
    method: "PATCH",
    secure: !0,
    format: "json",
    ...s
  });
}, Io = class extends D {
  scenesList = (e, t = {}) => this.request({
    path: "/scenes",
    method: "GET",
    query: e,
    secure: !0,
    format: "json",
    ...t
  });
  scenesCreate = (e, t = {}) => this.request({
    path: "/scenes",
    method: "POST",
    body: e,
    secure: !0,
    type: h.FormData,
    format: "json",
    ...t
  });
  scenesPartialUpdate = (e, t, r = {}) => this.request({
    path: `/scenes/${e}`,
    method: "PATCH",
    body: t,
    secure: !0,
    type: h.FormData,
    format: "json",
    ...r
  });
  scenesDelete = (e, t, r = {}) => this.request({
    path: `/scenes/${e}`,
    method: "DELETE",
    body: t,
    secure: !0,
    type: h.Json,
    ...r
  });
  scenesDetail = (e, t = {}) => this.request({
    path: `/scenes/${e}`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  transferCreate = (e, t, r = {}) => this.request({
    path: `/scenes/${e}/transfer`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.Json,
    ...r
  });
  accessorsList = (e, t = {}) => this.request({
    path: `/scenes/${e}/accessors`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  accessorsCreate = (e, t, r = {}) => this.request({
    path: `/scenes/${e}/accessors`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.Json,
    format: "json",
    ...r
  });
  accessorsPartialUpdate = (e, t, r, s = {}) => this.request({
    path: `/scenes/${e}/accessors/${t}`,
    method: "PATCH",
    body: r,
    secure: !0,
    type: h.Json,
    format: "json",
    ...s
  });
  accessorsDelete = (e, t, r = {}) => this.request({
    path: `/scenes/${e}/accessors/${t}`,
    method: "DELETE",
    secure: !0,
    ...r
  });
  accessorsDetail = (e, t, r = {}) => this.request({
    path: `/scenes/${e}/accessors/${t}`,
    method: "GET",
    secure: !0,
    format: "json",
    ...r
  });
  filesCreate = (e, t, r = {}) => this.request({
    path: `/scenes/${e}/files`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.FormData,
    format: "json",
    ...r
  });
  filesDetail = (e, t, r = {}) => this.request({
    path: `/scenes/${e}/files/${t}`,
    method: "GET",
    secure: !0,
    ...r
  });
  contentsHistoryList = (e, t, r = {}) => this.request({
    path: `/scenes/${e}/contents/history`,
    method: "GET",
    query: t,
    secure: !0,
    format: "json",
    ...r
  });
  contentsRollbackCreate = (e, t, r = {}) => this.request({
    path: `/scenes/${e}/contents/rollback`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.Json,
    format: "json",
    ...r
  });
  copyCreate = (e, t, r = {}) => this.request({
    path: `/scenes/${e}/copy`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.Json,
    format: "json",
    ...r
  });
  contentsCreate = (e, t, r = {}) => this.request({
    path: `/scenes/${e}/contents`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.FormData,
    format: "json",
    ...r
  });
  contentsList = (e, t, r = {}) => this.request({
    path: `/scenes/${e}/contents`,
    method: "GET",
    query: t,
    secure: !0,
    format: "json",
    ...r
  });
  contentsDelete = (e, t, r = {}) => this.request({
    path: `/scenes/${e}/contents/${t}`,
    method: "DELETE",
    secure: !0,
    ...r
  });
  contentsDetail = (e, t, r, s = {}) => this.request({
    path: `/scenes/${e}/contents/${t}`,
    method: "GET",
    query: r,
    secure: !0,
    format: "json",
    ...s
  });
  membersList = (e, t = {}) => this.request({
    path: `/scenes/${e}/members`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  membersTeamsCreate = (e, t, r = {}) => this.request({
    path: `/scenes/${e}/members/teams`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.Json,
    ...r
  });
  membersUsersCreate = (e, t, r = {}) => this.request({
    path: `/scenes/${e}/members/users`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.Json,
    ...r
  });
  orderPartialUpdate = (e, t = {}) => this.request({
    path: "/scenes/order",
    method: "PATCH",
    body: e,
    secure: !0,
    type: h.Json,
    ...t
  });
}, Bo = class extends D {
  checkoutSessionsConfirmCreate = (e, t = {}) => this.request({
    path: `/subscriptions/checkout-sessions/${e}/confirm`,
    method: "POST",
    secure: !0,
    format: "json",
    ...t
  });
  tiersList = (e = {}) => this.request({
    path: "/subscriptions/tiers",
    method: "GET",
    secure: !0,
    format: "json",
    ...e
  });
  invoicesList = (e = {}) => this.request({
    path: "/subscriptions/invoices",
    method: "GET",
    secure: !0,
    format: "json",
    ...e
  });
  stripePublishableKeyList = (e = {}) => this.request({
    path: "/subscriptions/stripe-publishable-key",
    method: "GET",
    secure: !0,
    format: "json",
    ...e
  });
  subscriptionsCreate = (e, t = {}) => this.request({
    path: "/subscriptions",
    method: "POST",
    body: e,
    secure: !0,
    type: h.Json,
    format: "json",
    ...t
  });
  userAddOnPartialUpdate = (e, t = {}) => this.request({
    path: "/subscriptions/user/add-on",
    method: "PATCH",
    body: e,
    secure: !0,
    type: h.Json,
    format: "json",
    ...t
  });
  stripeCardIntentList = (e, t = {}) => this.request({
    path: `/subscriptions/${e}/stripe-card-intent`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  paymentMethodsCardsList = (e, t = {}) => this.request({
    path: `/subscriptions/${e}/payment-methods/cards`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  paymentMethodsCardsDelete = (e, t = {}) => this.request({
    path: `/subscriptions/payment-methods/cards/${e}`,
    method: "DELETE",
    secure: !0,
    ...t
  });
  paymentMethodsCardsPartialUpdate = (e, t, r = {}) => this.request({
    path: `/subscriptions/payment-methods/cards/${e}`,
    method: "PATCH",
    body: t,
    secure: !0,
    type: h.Json,
    ...r
  });
  cancelCreate = (e, t, r = {}) => this.request({
    path: `/subscriptions/cancel/${e}`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.Json,
    format: "json",
    ...r
  });
  activatePartialUpdate = (e, t = {}) => this.request({
    path: `/subscriptions/activate/${e}`,
    method: "PATCH",
    secure: !0,
    format: "json",
    ...t
  });
}, Jo = class extends D {
  creditsList = (e, t = {}) => this.request({
    path: `/teams/${e}/credits`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  creditsGrantsList = (e, t, r = {}) => this.request({
    path: `/teams/${e}/credits/grants`,
    method: "GET",
    query: t,
    secure: !0,
    format: "json",
    ...r
  });
  creditsTopupSessionCreate = (e, t, r = {}) => this.request({
    path: `/teams/${e}/credits/topup-session`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.Json,
    format: "json",
    ...r
  });
  creditsSettingsList = (e, t = {}) => this.request({
    path: `/teams/${e}/credits/settings`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  creditsSettingsUpdate = (e, t, r = {}) => this.request({
    path: `/teams/${e}/credits/settings`,
    method: "PUT",
    body: t,
    secure: !0,
    type: h.Json,
    format: "json",
    ...r
  });
  serviceAccountsCreate = (e, t, r = {}) => this.request({
    path: `/teams/${e}/service-accounts`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.Json,
    format: "json",
    ...r
  });
  serviceAccountsList = (e, t = {}) => this.request({
    path: `/teams/${e}/service-accounts`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  serviceAccountsPartialUpdate = (e, t, r, s = {}) => this.request({
    path: `/teams/${e}/service-accounts/${t}`,
    method: "PATCH",
    body: r,
    secure: !0,
    type: h.Json,
    format: "json",
    ...s
  });
  serviceAccountsDelete = (e, t, r = {}) => this.request({
    path: `/teams/${e}/service-accounts/${t}`,
    method: "DELETE",
    secure: !0,
    ...r
  });
  serviceAccountsCredentialsCreate = (e, t, r, s = {}) => this.request({
    path: `/teams/${e}/service-accounts/${t}/credentials`,
    method: "POST",
    body: r,
    secure: !0,
    type: h.Json,
    format: "json",
    ...s
  });
  serviceAccountsCredentialsList = (e, t, r = {}) => this.request({
    path: `/teams/${e}/service-accounts/${t}/credentials`,
    method: "GET",
    secure: !0,
    format: "json",
    ...r
  });
  serviceAccountsCredentialsDelete = (e, t, r, s, o = {}) => this.request({
    path: `/teams/${e}/service-accounts/${t}/credentials/${r}`,
    method: "DELETE",
    query: s,
    secure: !0,
    ...o
  });
  foldersList = (e, t = {}) => this.request({
    path: `/teams/${e}/folders`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  projectsList = (e, t, r = {}) => this.request({
    path: `/teams/${e}/projects`,
    method: "GET",
    query: t,
    secure: !0,
    format: "json",
    ...r
  });
  scenesList = (e, t, r = {}) => this.request({
    path: `/teams/${e}/scenes`,
    method: "GET",
    query: t,
    secure: !0,
    format: "json",
    ...r
  });
  teamsList = (e, t = {}) => this.request({
    path: "/teams",
    method: "GET",
    query: e,
    secure: !0,
    format: "json",
    ...t
  });
  teamsCreate = (e, t = {}) => this.request({
    path: "/teams",
    method: "POST",
    body: e,
    secure: !0,
    type: h.Json,
    format: "json",
    ...t
  });
  teamsPartialUpdate = (e, t, r = {}) => this.request({
    path: `/teams/${e}`,
    method: "PATCH",
    body: t,
    secure: !0,
    type: h.Json,
    ...r
  });
  teamsDetail = (e, t = {}) => this.request({
    path: `/teams/${e}`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  teamsDelete = (e, t = {}) => this.request({
    path: `/teams/${e}`,
    method: "DELETE",
    secure: !0,
    ...t
  });
  usersList = (e, t = {}) => this.request({
    path: `/teams/${e}/users`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  subscriptionInvoicesList = (e, t = {}) => this.request({
    path: `/teams/${e}/subscription/invoices`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  quotaList = (e, t = {}) => this.request({
    path: `/teams/${e}/quota`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  quotaCreate = (e, t, r = {}) => this.request({
    path: `/teams/${e}/quota`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.Json,
    format: "json",
    ...r
  });
  quotaUpdate = (e, t, r = {}) => this.request({
    path: `/teams/${e}/quota`,
    method: "PUT",
    body: t,
    secure: !0,
    type: h.Json,
    format: "json",
    ...r
  });
  usersDelete = (e, t, r = {}) => this.request({
    path: `/teams/${e}/users/${t}`,
    method: "DELETE",
    secure: !0,
    ...r
  });
  profileImageCreate = (e, t, r = {}) => this.request({
    path: `/teams/${e}/profile-image`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.FormData,
    ...r
  });
  profileImageDelete = (e, t = {}) => this.request({
    path: `/teams/${e}/profile-image`,
    method: "DELETE",
    secure: !0,
    ...t
  });
  packsList = (e, t = {}) => this.request({
    path: `/teams/${e}/packs`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  packsCreate = (e, t, r, s = {}) => this.request({
    path: `/teams/${e}/packs/${t}`,
    method: "POST",
    body: r,
    secure: !0,
    type: h.Json,
    ...s
  });
  packsDelete = (e, t, r = {}) => this.request({
    path: `/teams/${e}/packs/${t}`,
    method: "DELETE",
    secure: !0,
    ...r
  });
}, Ho = class extends D {
  usersList = (e = {}) => this.request({
    path: "/users",
    method: "GET",
    secure: !0,
    format: "json",
    ...e
  });
  usersPartialUpdate = (e, t = {}) => this.request({
    path: "/users",
    method: "PATCH",
    body: e,
    secure: !0,
    type: h.Json,
    ...t
  });
  usersDelete = (e, t = {}) => this.request({
    path: `/users/${e}`,
    method: "DELETE",
    secure: !0,
    ...t
  });
  usersDetail = (e, t, r = {}) => this.request({
    path: `/users/${e}/${t}`,
    method: "GET",
    secure: !0,
    format: "json",
    ...r
  });
  usersCreate = (e, t, r = {}) => this.request({
    path: `/users/${e}/${t}`,
    method: "POST",
    secure: !0,
    format: "json",
    ...r
  });
  teamsList = (e, t = {}) => this.request({
    path: `/users/${e}/teams`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  teamsCreate = (e, t, r = {}) => this.request({
    path: `/users/${e}/teams`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.Json,
    ...r
  });
  profileList = (e = {}) => this.request({
    path: "/users/profile",
    method: "GET",
    secure: !0,
    format: "json",
    ...e
  });
  profileProfileImageCreate = (e, t = {}) => this.request({
    path: "/users/profile/profile-image",
    method: "POST",
    body: e,
    secure: !0,
    type: h.FormData,
    ...t
  });
  profileProfileImageDelete = (e = {}) => this.request({
    path: "/users/profile/profile-image",
    method: "DELETE",
    secure: !0,
    format: "json",
    ...e
  });
  accountRecoveryDetail = (e, t = {}) => this.request({
    path: `/users/account-recovery/${e}`,
    method: "GET",
    secure: !0,
    ...t
  });
  accountRecoveryCreate = (e, t = {}) => this.request({
    path: "/users/account-recovery",
    method: "POST",
    body: e,
    secure: !0,
    type: h.Json,
    ...t
  });
  invitationsList = (e = {}) => this.request({
    path: "/users/invitations",
    method: "GET",
    secure: !0,
    format: "json",
    ...e
  });
  avatarsList = (e, t = {}) => this.request({
    path: `/users/${e}/avatars`,
    method: "GET",
    secure: !0,
    format: "json",
    ...t
  });
  avatarsCreate = (e, t, r = {}) => this.request({
    path: `/users/${e}/avatars`,
    method: "POST",
    body: t,
    secure: !0,
    type: h.FormData,
    format: "json",
    ...r
  });
  avatarsDelete = (e, t, r = {}) => this.request({
    path: `/users/${e}/avatars/${t}`,
    method: "DELETE",
    secure: !0,
    ...r
  });
}, Mo = /* @__PURE__ */ (function(e) {
  return e.Free = "Free", e.Paid = "Paid", e.Enterprise = "Enterprise", e;
})({}), Go = /* @__PURE__ */ (function(e) {
  return e.Private = "Private", e.MyContent = "MyContent", e;
})({}), zo = /* @__PURE__ */ (function(e) {
  return e.Horizontal = "Horizontal", e.Vertical = "Vertical", e.Free = "Free", e;
})({}), Wo = /* @__PURE__ */ (function(e) {
  return e.None = "None", e.Image = "Image", e.Video = "Video", e.Model = "Model", e.Trace = "Trace", e.Component = "Component", e.Material = "Material", e.Animation = "Animation", e.Style = "Style", e.Form = "Form", e.Template = "Template", e.Any = "Any", e.Scene = "Scene", e.Project = "Project", e.Audio = "Audio", e.Font = "Font", e.Showcase = "Showcase", e.VFX = "VFX", e.Avatar = "Avatar", e.Wrapper = "Wrapper", e;
})({}), Vo = /* @__PURE__ */ (function(e) {
  return e.Refunded = "Refunded", e.AlreadyRefunded = "AlreadyRefunded", e.DebitNotFound = "DebitNotFound", e;
})({}), Ko = /* @__PURE__ */ (function(e) {
  return e.Consumed = "Consumed", e.AlreadyProcessed = "AlreadyProcessed", e.InsufficientBalance = "InsufficientBalance", e.InvalidUnits = "InvalidUnits", e.UnknownAction = "UnknownAction", e;
})({}), Xo = /* @__PURE__ */ (function(e) {
  return e.Legacy = "Legacy", e.Folder = "Folder", e;
})({}), Qo = /* @__PURE__ */ (function(e) {
  return e.Local = "Local", e.Temp = "Temp", e.Image = "Image", e.Immersal = "Immersal", e;
})({}), Zo = /* @__PURE__ */ (function(e) {
  return e.Hour = "Hour", e.Day = "Day", e.Week = "Week", e;
})({}), Yo = /* @__PURE__ */ (function(e) {
  return e.Subject = "Subject", e.Platform = "Platform", e.App = "App", e.Event = "Event", e.Context = "Context", e;
})({}), en = /* @__PURE__ */ (function(e) {
  return e.Location = "Location", e.Anywhere = "Anywhere", e;
})({});
export {
  en as AccessType,
  Yo as AnalyticsBreakdownDimension,
  Zo as AnalyticsGranularity,
  Qo as AnchorType,
  Do as Assets,
  Lo as Auth,
  _o as Avatars,
  $o as Catalogs,
  go as CmsError,
  xo as Code,
  Uo as Contactus,
  Xo as ContentStorage,
  h as ContentType,
  Ko as CreditConsumeOutcome,
  Vo as CreditRefundOutcome,
  Oo as DEFAULT_ANCHOR_WIDTH_METERS,
  Wo as EntityType,
  Fo as Experiences,
  No as Folders,
  Wt as GROMA_LOCALIZER_KIND,
  D as HttpClient,
  ar as IMAGE_ANCHOR_TYPE,
  ao as IMAGE_LOCALIZER_KIND,
  zo as Orientation,
  ko as Projects,
  Go as QueryFlagType,
  So as SERVER_TOOLS,
  Io as Scenes,
  Bo as Subscriptions,
  Mo as TeamSubscriptionPlanType,
  Jo as Teams,
  Ho as Users,
  Co as attachCmsContent,
  yo as buildCatalogIndex,
  qo as buildCmsSceneInput,
  po as cachedCatalogIndex,
  Eo as cmsGet,
  lt as contentDisplayName,
  ct as contentDownloadUrl,
  pt as effectiveScenePlacements,
  it as findAnchoringPlacement,
  Le as findImageAccessor,
  er as findRootContent,
  To as getAsset,
  Ao as isSceneAnchored,
  no as legacyPlacementRotation,
  Po as loadCmsScene,
  oo as normalizeRotation,
  Xt as parseScenePlacements,
  uo as placementRotationFromPitch,
  at as projectPlacementToLegacyAnchor,
  dt as resolveImageAnchorUrl,
  ho as resolveLocalizerSelection,
  mo as searchIndex,
  bo as serverTool,
  io as toScenePlacementsWriteRequest,
  lo as trackableImageLocalizers,
  vo as trackedLocalizersFromPlacements
};

//# sourceMappingURL=cms.js.map